import React, { FC, useEffect, useState } from "react"
import { useStore } from "stores/utils/use-store"
import { Button, Modal, Table } from "antd"
import { CopyOutlined } from "@ant-design/icons"
import { bannersColumns } from "./columns"
import { observer } from "mobx-react"
import { BannerEdit } from "./in-game-banners-edit"
import { DeleteIconButton, showDeleteConfirm, CreateNewElement } from "components"
import { Column } from "abstract/types/column.type"
import { ConfigItemAtList } from "domains/managingJson/store/types"

export const InGameBannersList: FC = observer(() => {
  const { dataStore: { managingJsonStore } } = useStore()
  const [isVisibleEditCreate, setEditCreateVisibility] = useState<"create" | "edit" | null>(null)
  const [isDuplicatePrefill, setDuplicatePrefill] = useState(false)
  const [banners, setbanners] = useState<any[]>()
  useEffect(() => {
    managingJsonStore.getData()
  }, [managingJsonStore])

  useEffect(() => {
    const inGameBanners = managingJsonStore?.itemTypes?.filter(item => item.type === "inGameBanners")
    setbanners(inGameBanners)
  }, [managingJsonStore.itemTypes])

  const getDuplicateName = (name?: string) => {
    if (!name) return ""
    const existingNames = new Set((banners ?? []).map(item => item.name))
    const baseName = `${name} (copy)`
    if (!existingNames.has(baseName)) return baseName
    let index = 2
    while (existingNames.has(`${baseName} ${index}`)) {
      index += 1
    }

    return `${baseName} ${index}`
  }

  const onClose = () => {
    setEditCreateVisibility(null)
    setDuplicatePrefill(false)
    managingJsonStore.clearSelectedElement()
  }

  const columns: Column[] = [
    ...bannersColumns,
    {
      title: "Actions",
      dataIndex: "id",
      key: "id",
      render: (_: any, row: ConfigItemAtList) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            icon={<CopyOutlined />}
            onClick={e => {
              e.stopPropagation()
              const duplicateName = getDuplicateName(row?.name)
              const duplicatedDraft = {
                type: row.type,
                name: duplicateName,
                data: row.data,
              } as ConfigItemAtList

              managingJsonStore.selectedElement = duplicatedDraft
              setDuplicatePrefill(true)
              setEditCreateVisibility("create")
            }}
          >
            Duplicate
          </Button>
          <DeleteIconButton
            onClick={e => {
              if (row?.name) {
                e.stopPropagation()
                showDeleteConfirm(row?.name, undefined, async() => {
                  managingJsonStore.funcAfterSuccess = async() => await managingJsonStore.getData()

                  await managingJsonStore.deleteByName(row?.name || "", "inGameBanners")
                })
              }
            }}
          />
        </div>
      ),
    },
  ]

  return (
    <>
      <CreateNewElement
        onClick={() => {
          managingJsonStore.clearSelectedElement()
          setDuplicatePrefill(false)
          setEditCreateVisibility("create")
        }}
        valueText="in-game banner"
      />

      <Table
        dataSource={banners}
        columns={columns as any}
        rowKey="id"
        onRow={(record: ConfigItemAtList) => ({
          onClick: () => {
            managingJsonStore.selectedElement = record
            setDuplicatePrefill(false)
            setEditCreateVisibility("edit")
          },
        })}
      />

      {isVisibleEditCreate && (
        <Modal
          visible
          title={isVisibleEditCreate === "edit" ? "Edit in-gamebanner" : "Create in-gamebanner"}
          width="700px"
          footer={null}
          onCancel={onClose}
          style={{ top: "10px" }}
        >
          <BannerEdit
            editType={isVisibleEditCreate}
            isDuplicatePrefill={isDuplicatePrefill}
            onClose={onClose}
          />
        </Modal>
      )}
    </>
  )
})
